import { LivretEleve } from '../types/livret';

export function getLSUStatus(
  livretEleve?: LivretEleve,
): 'ok' | 'ko' | undefined {
  if (!livretEleve) {
    return undefined;
  }
  if ((livretEleve?.lsuErrors || []).length > 0) {
    return 'ko';
  }
  return 'ok';
}
